export const stationAppPanel = {
  displayNames: false,
};
